import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { List as AntList, Tabs, Spin, Modal, Icon } from 'antd'
import _ from 'lodash'
import { get } from '../../utils/sockets'
import { getAttribute } from '../../utils/models'
import List from '../List'
import Format from '../Format'
import ShowModal from '../ShowModal'
import Title from '../Title'
import config from '../../config/custom'
import { getModelName, getAttributes } from '../../utils/models'
import { FormattedMessage } from 'react-intl'

import './index.css'

const TabPane = Tabs.TabPane

class Detail extends Component {

    constructor(props) {
        super(props)

        this.state = {
            data: {},
            loading: true,
            visible: true
        }
    }

    componentDidMount() {
        this.getData()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.model !== this.props.model
            || prevProps.id !== this.props.id) {
            this.getData()
        }
    }

    getData() {
        get(`${config.baseUrl}/${this.props.model}/${this.props.id}`)
            .then(response => {
                this.setState({ data: response })
            })
            .catch(() => {
                // 
            })
            .then(() => {
                this.setState({ loading: false })
            })
    }

    getDescription(attribute) {
        const data = this.state.data[attribute]

        if (data &&
            typeof data === 'object' &&
            data.hasOwnProperty('id') &&
            !this.props.disabled) {
            const model = getModelName(this.props.model, attribute)

            return (
                <ShowModal type="detail" model={model} id={data.id}>
                    <div className="detail-link">
                        <Format
                            model={this.props.model}
                            attribute={attribute}
                            value={this.state.data[attribute]}
                        />
                        <Icon type="arrow-right" />
                    </div>
                </ShowModal>
            )
        }

        return <Format
            model={this.props.model}
            attribute={attribute}
            value={this.state.data[attribute]}
        />
    }

    hide() {
        this.setState({ visible: false }, () => {
            this.props.hide()
        })
    }

    render() {
        const extraColumns = ['id', 'createdAt', 'updatedAt']

        const attributes = getAttributes(this.props.model, this.props.attribute)

        let columns = _.keys(_.pickBy(attributes, i => !i.hasOwnProperty('collection')))

        columns = [...extraColumns, ...columns]

        const collections = _.pickBy(attributes, (i, attribute) => {
            const model = getModelName(this.props.model, attribute)
            return i.hasOwnProperty('collection') && model !== 'dispatch'
        })

        return (
            <Modal
                title={<Title model={this.props.model} value={this.state.data} />}
                visible={this.state.visible}
                footer={null}
                width={800}
                onCancel={() => { this.hide() }}
            >
                <div style={{ marginTop: -25 }}>
                    <Spin spinning={this.state.loading}>
                        <Tabs defaultActiveKey="details">
                            <TabPane tab={<FormattedMessage id={'Detail.title'} />} key="details">
                                <AntList
                                    itemLayout="horizontal"
                                    dataSource={columns}
                                    renderItem={attribute => {
                                        const id = _.includes(extraColumns, attribute) ? `Attribute.${attribute}` : `Attribute.${this.props.model}.${attribute}`

                                        return (
                                            <AntList.Item>
                                                <AntList.Item.Meta
                                                    title={<FormattedMessage id={id} />}
                                                    description={this.getDescription(attribute)}
                                                />
                                            </AntList.Item>
                                        )
                                    }}
                                />
                            </TabPane>
                            {_.keys(collections).map(key => (
                                <TabPane tab={<FormattedMessage id={`Attribute.${this.props.model}.${key}`} />} key={key}>
                                    <List
                                        model={getModelName(this.props.model, key)}
                                        belongsTo={{ association: getAttribute(this.props.model, key).via, id: this.props.id }} />
                                </TabPane>
                            ))}
                        </Tabs>
                    </Spin>
                </div>
            </Modal>
        )
    }
}

Detail.propTypes = {
    model: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired
}

export default Detail



// WEBPACK FOOTER //
// ./src/containers/Detail/index.js